import { Link } from "react-router-dom"
import { Container, Navbar } from "reactstrap"
import styled from "styled-components"

export const StyledNavbar = styled(Navbar).attrs(() => ({
    className: "navbar-vertical fixed-left navbar-light", expand: "md",
    id: "sidenav-main"
}))``

export const StyledContainer = styled(Container).attrs(() => ({
    className: "navbar-vertical flex-nowrap  navbar-light fixed-left mobile-fixes ", expand: "md",
    id: "sidenav-main", fluid: true
}))``

export const StyledList = styled.li.attrs(() => ({
    className: "nav-item list-unstyled w-100"
}))``

export const StyledLink = styled(Link).attrs(() => ({
    className: "navbar-vertical flex-nowrap  navbar-light fixed-left mobile-fixes", expand: "md",
    id: "sidenav-main", fluid: true
}))``


export const StyledIcon = styled.i.attrs(({ icon }) => ({
    className: `${icon} text-center Icon`
}))`font-size: 30px;
min-width: 2.25rem;
vertical-align: middle;`

export const StyledSPan1 = styled.span`
margin-left: 5px;
margin-right: 5px;
`


export const StyledSPan2 = styled.span`
font-family: 'Lato', sans-serif;
font-size: 1rem;
padding-top: 2px;
vertical-align: middle;
`

export const StyledSPan3 = styled.span`
cursor: pointer;
display: flex;
align-items: center;
`

export const StyledSPan4 = styled.span`
font-family:'Lato', sans-serif;
vertical-align: middle;
font-size: 1rem;
`


export const StyledIcon2 = styled.i.attrs(({ icon }) => ({
    className: `icon-signout text-center text-red Icon`
}))`font-size: 30px;
min-width: 2.25rem;
vertical-align: middle;`